import { Flex, Text } from '@chakra-ui/react'
import { ListDividerItem } from '@hb/shared'
import { CSSProperties } from 'react'

export const ListDividerView = ({
  item,
  style,
  mobileLayout,
}: {
  item: ListDividerItem
  style?: CSSProperties
  mobileLayout?: boolean
}) => (
  <Flex
    align="center"
    // bg={'#e1e1e1'}
    bg="#ffaead"
    _dark={{ bg: '#aa5577', borderColor: 'gray.800' }}
    position="relative"
    borderTop="1px solid"
    borderBottom="1px solid"
    borderColor="gray.200"
    left={0}
    justify={mobileLayout ? 'center' : 'flex-start'}
    height="100%"
    width="100%"
    px={3}
    style={style}>
    <Text as="span" textShadow="1px 1px 3px #00000066" fontSize="sm" fontWeight={600} color="white">
      {item.label.toUpperCase()}
    </Text>
  </Flex>
)
